module.exports = __webpack_public_path__ + "static/img/meta.779779b4.svg";